import React, { useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, FieldCheckboxGroup, Form } from '../../components';
import access from './images/access2.png';
import calendar from './images/calendar2.png';
import contact from './images/contact1.png';
import diversity from './images/diversity4.png';
import payment from './images/payment3.png';
import writing from './images/writing1.png';

import css from './EditListingGuidelinesForm.module.css';

const EditListingGuidelinesFormComponent = props => {
    const [checked, setChecked] = useState(props.listingPublicData.guidelines ? true : false);
    const handleChecked = () =>{
      setChecked(!checked)
      console.log(checked)
    }
  return (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        disabled,
        ready,
        rootClassName,
        className,
        name,
        handleSubmit,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        filterConfig,
      } = formRenderProps;
      const isPublished = props.isPublished;
      const classes = classNames(rootClassName || css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = disabled || submitInProgress;

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingGuidelinesForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingGuidelinesForm.showListingFailed" />
        </p>
      ) : null;

      const options = findOptionsForSelectFilter('guidelines', filterConfig);
      

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}
          <p>We want to help you succeed on AppBuddy. Please avoid the following to keep in line with our community standards:</p>
          <div className={css.guidelinesWrapper}>

            <div className={css.guidelinesTopRow}>

                <div className={css.gDiversity}>
                  <img src={diversity} className={css.gImage}/>
                  <p>Hate and/or violence against individuals based on race or ethnicity, religion, disability, gender, age, nationality, sexual orientation or gender identity.</p>

                </div>
                <div className={css.gPayment}>
                  <img src={payment} className={css.gImage}/>
                  <p>Accepting payment from students outside of the platform.</p>
                </div>
                <div className={css.gCalendar}>
                  <img src={calendar} className={css.gImage}/>
                  <p>Canceling and/or not attending scheduled sessions. Once you confirm you are attending a session, it is expected that you will attend.</p>
                </div>

            </div>
            <div className={css.guidelinesBottomRow}>

                <div className={css.gContact}>
                   <img src={contact} className={css.gImage}/>
                  <p>Sharing ANY contact information. Asides from your first name, AppBuddy asks you not to share any external contact information or any details that can be used by a student to get in touch with you outside of the platform. This includes but is not limited to sharing your full name, email, phone number, Instagram, Facebook, Skype, etc. </p>
                </div>
                <div className={css.gWriting}>
                   <img src={writing} className={css.gImage}/>
                    <p>Writing essays for applicants. This is strictly against AAMC/AMCAS/AACOMAS/ADA/AADSAS and our terms of service. </p>
                </div>
                <div className={css.gAccess}>
                  <img src={access} className={css.gImage}/>
                  <p>Sharing and/or distributing essays as well as discussing content of sessions to a third-party is strictly prohibited.</p>
                </div>
              
            </div>

          </div>
          <FieldCheckboxGroup className={isPublished ? css.publishedGuidelines : css.guidelines} id={name} name={name} options={options} handleChecked={handleChecked}/>

          {!isPublished ? 
          <Button
            className={ checked ? css.submitButton : css.disabledSubmitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button> : null
          }
          
        </Form>
      );
    }}
  />
)};

EditListingGuidelinesFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
  filterConfig: config.custom.filters,
};

EditListingGuidelinesFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  name: string.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  filterConfig: propTypes.filterConfig,
};

const EditListingGuidelinesForm = EditListingGuidelinesFormComponent;

export default EditListingGuidelinesForm;
